import React from 'react';
import ReactDOM from 'react-dom/client';
import './index';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Store/index';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <Provider store={store}><App /></Provider>
    </BrowserRouter>

);

